import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount, ref, computed } from 'vue'
import ko from 'knockout'
import 'devexpress-reporting/dx-webdocumentviewer'

import 'jquery-ui/themes/base/all.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css'
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css'
import environment from '@/configs/environtment'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentViewer',
  props: {
  typeReport: {
    type: String,
    required: true,
  }
},
  setup(__props) {

const props = __props



console.log('props:', props)

const typeReport = computed(() => props.typeReport)
const refViewer = ref()

const initialize = () => {
  const observableUrl = typeReport.value
  const url = environment.getApiReporting()
  const viewerOptions = {
    reportUrl: ko.observable(`${observableUrl}`), // The URL of a report.
    requestOptions: {
      host: url,
      invokeAction: 'DXXRDV'
    },
  }
  ko.applyBindings(viewerOptions, refViewer.value)
}

onMounted(() => {
  initialize()
})

onBeforeUnmount(() => {
  ko.cleanNode(refViewer.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refViewer",
    ref: refViewer,
    style: {"position":"absolute","left":"0","right":"0","top":"0","bottom":"0"},
    "data-bind": "dxReportViewer: $data"
  }, null, 512))
}
}

})